import { defaultKeywords } from '../../../Assets/Meta'

export const getCourseKeywords = (teacherName, instruments = []) =>
  `${defaultKeywords}, ${teacherName}` +
  instruments.reduce((all, current) => `${all}, ${current}`, '')
